import React, { useState, useMemo } from "react"
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TextField,
    InputAdornment
} from "@mui/material"
import { KeyboardArrowDown, Search } from "@mui/icons-material"
import { sxSelect, sxMenuPaper } from "./ComboBoxSx"

export default function ComboBoxGestaoEventos({ name, options = [], defaultValue, onChange, valor, label, disabled, newSx = {} }) {
    const [searchText, setSearchText] = useState("")

    const Teste = (obj, searchText) => {
        let value = obj[valor].toString()
        let descricao = obj[label]
        const option = value.toLowerCase() + " - " + descricao.toLowerCase()
        return option.indexOf(searchText.toLowerCase()) > -1
    }

    const displayedOptions = useMemo(
        () => options.filter((option) => Teste(option, searchText)),
        [searchText]
    )

    const renderValue = (selectedValue, options) => {
        const selectedOption = options.find((option) => option[valor] === selectedValue)
        const result = selectedOption[label]
        return result
    }

    return (
        <Box >
            {options &&
            <FormControl sx={{ width: '100%', color: 'black' }}>
                {/* <Typography id="search-select-label">Revenda</Typography> */}
                <Select
                    name={name}
                    disabled={disabled}
                    sx={{ ...sxSelect, ...newSx }}
                    defaultValue={defaultValue}
                    MenuProps={{
                        autoFocus: false,
                        PaperProps: { sx: sxMenuPaper },
                        sx: { '& .Mui-selected': { backgroundColor: '#9d56b93f' } }
                    }} // Disables auto focus on MenuItems and allows TextField to be in focus
                    inputProps={{
                        sx: { padding: '0 5px' }
                    }}
                    labelId="search-select-label"
                    IconComponent={KeyboardArrowDown}
                    id="navbar_revenda_select"
                    onChange={onChange}
                    onClose={() => setSearchText("")}
                    // This prevents rendering empty string in Select's value
                    // if search text would exclude currently selected option.
                    renderValue={(selectedValue) => renderValue(selectedValue, options)}
                >
                    {/* TextField is put into ListSubheader so that it doesn't
              act as a selectable item in the menu
              i.e. we can click the TextField without triggering any selection. */}
                    <ListSubheader>
                        <TextField
                            size="small"
                            // Autofocus on textfield
                            autoFocus
                            placeholder="Pesquisar condominio..."
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation()
                                }
                            }}
                        />
                    </ListSubheader>

                    {displayedOptions.map((option, i) => (
                        option[valor] &&
                            <MenuItem sx={{ height: '30px' }} key={`menu_combo_${i}`} value={option[valor]}>
                                {option[label]}
                            </MenuItem>
                    ))}
                </Select>
            </FormControl>
            }
        </Box>
    )
}
